import React from "react";
import { EventBus } from "@/store/event-bus";
import Textarea from "@/components/ui/Textarea";
import { toast } from "react-toastify";
import Modal from "@/components/ui/Modal";
import Button from "@/components/ui/Button";

import { constants } from "@/constants.js";
import { urlChatID } from "@/utils/url.js";

import LoadingSpinner from "@/components/partials/LoadingSpinner.jsx";
import { useQueryClient } from "react-query";
import { queryKeyChatbotSummary } from "@/pages/chatbot/sources/ChatBotSources";
import ListQuestions from "@/pages/chatbot/sources/ListQuestions";
import {useTranslation} from "react-i18next";

interface ItemQA {
  id?: string;
  question?: string;
  text?: string;
}

const ChatBotSourcesQuestion = () => {
  const {t} = useTranslation();
  const queryClient = useQueryClient();
  const [uploading, setUploading] = React.useState(false);
  const [item, setItem] = React.useState({} as ItemQA);
  const [editItem, setEditItem] = React.useState(null as null | ItemQA);

  const [modalOpen, setModalOpen] = React.useState(false);

  const addQuestion = async (item: ItemQA) => {
    if (!item.text) {
      toast.error("Empty text field", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
      return;
    }

    setUploading(true);
    try {
      let res = await fetch(
        `${constants.url.API_PREFIX}chatbot/${urlChatID()}/questions/add`,
        {
          method: "POST",
          body: JSON.stringify(item),
        },
      );
      let json = await res.json();
      if (json.error) {
        toast.error(json.error, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      } else if (json.message) {
        toast.success(json.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } catch (e) {
      toast.error("Text add error", {
        position: "top-right",
        autoClose: 1500,
        theme: "light",
      });
    }
    setUploading(false);
    EventBus.getInstance().dispatch("chatbot.sources.questions.add");
    queryClient.invalidateQueries(queryKeyChatbotSummary);
  };

  return (
    <div>
      <div className="bg-slate-50 p-4 rounded-lg">
        <ItemEditForm item={item} onChange={setItem} />

        <div className="mt-6 flex justify-end">
          <button
            type="submit"
            className="btn btn inline-flex justify-center btn-primary btn"
            onClick={() => {
              addQuestion(item);
            }}
          >
            <span className="flex items-center">
              <span>{uploading ? <LoadingSpinner /> : t("add")}</span>
            </span>
          </button>
        </div>
      </div>

      <ListQuestions
        onItemEdit={(item: ItemQA) => {
          setEditItem(item);
          setModalOpen(true);
        }}
      />

      <Modal
        title={t("edit")}
        // label="Disabled animation"
        uncontrol={false}
        activeModal={modalOpen}
        labelClass="btn-outline-primary"
        themeClass="bg-primary-500"
        noFade
        onClose={() => {
          setModalOpen(false);
        }}
        centered={true}
        footerContent={
          <Button
            text={t("save")}
            className="btn-primary"
            onClick={() => {
              addQuestion(editItem as ItemQA);
              setModalOpen(false);
            }}
          />
        }
      >
        <ItemEditForm item={editItem} onChange={setEditItem} />
      </Modal>
    </div>
  );
};

const ItemEditForm = (props: any) => {
  const {t} = useTranslation();

  return (
    <div>
      {/*@ts-ignore*/}
      <Textarea
        label={t("knowledge_base.qa.question")}
        type="text"
        placeholder=""
        row={3}
        value={props.item.question}
        onChange={(e: any) => {
          let item = Object.assign({}, props.item);
          item.question = e.target.value;
          props.onChange(item);
        }}
      />

      <div className="mt-4">
        {/*@ts-ignore*/}
        <Textarea
          label={t("knowledge_base.qa.answer")}
          placeholder=""
          row={6}
          value={props.item.text}
          onChange={(e: any) => {
            let item = Object.assign({}, props.item);
            item.text = e.target.value;
            props.onChange(item);
          }}
        />
      </div>
    </div>
  );
};

export default ChatBotSourcesQuestion;
